<template>
  <div class="w1200 newsBox">
    <div class="bannerBox">
      <Banner :big="true" />
    </div>
    <div class="leftBox">
      <div>
        <Firstcolumn v-if="newsIinitData.albumType" :columnlist="columnlist" :alldata="newsIinitData" />
      </div>
    </div>
    <div class="rightBox">
      <Rightlist />
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner_smoll'
import Firstcolumn from '@/views/firstlist/firstcolumn_album'
import Rightlist from '@/components/commonRightList'
export default {
  components: { Banner, Firstcolumn, Rightlist },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '专辑网刊-家谱范本_家谱合辑_家谱网刊_最新专辑_家谱图-彭祖世家网',
      mateDesc: '百家姓家谱专辑,百家家谱合辑,姓氏家谱,家谱网刊,家谱发布,家谱修订,免费家谱网刊等海量专辑收录',
      keys: '修谱,修谱方法,修谱的意义,修谱倡议,修谱网,修谱诗词,修谱软件'
    }
  },
  computed: {
    columnlist() {
      var arrs = this.$store.state.albumnData.albumType
      if (arrs) {
        if (arrs[0].value !== '') {
          arrs.unshift({ 'value': '', 'name': '全部' })
        }
      }
      return arrs
    },

    newsIinitData() {
      return this.$store.state.albumnData
    }
  },
  asyncData({ store, route }) {
    return store.dispatch('getalbumInitData')
  },
  mounted() {
    this.fn()
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .newsBox{
    background-color: #fafafa;
    overflow: hidden;
    position: relative;
    .bannerBox{
      width: 1200px;
      height: 340px;
      margin-top: 20px;
    }
  }
  .leftBox{
    width: 880px;
    margin-right: 20px;
    margin-top: 20px;
    float: left;
  }
  .rightBox{
    width: 300px;
    /*margin-left: 20px;*/
    margin-top: 20px;
    float: right;
    /*top: 0;*/
    /*right: 0;*/
    overflow: hidden;
  }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .newsBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
      }
    }
    .leftBox{
      width: 100%;
      margin-top: 0;
    }
    .rightBox{
      display: none;
    }
  }
</style>
